import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { AppRoutes } from "AppRoutes";
import DocumentName from "components/DocumentName";
import { Link } from "react-router-dom";
import { P } from "theme/typography";
import { GenerateProfileResponseSampleEvent } from "../EventInterfaces";

const SampleEventTable = (props: { lensId: number; sampleEvents: GenerateProfileResponseSampleEvent[] }) => {
  const { lensId, sampleEvents } = props;
  return (
    <TableContainer>
      <Table stickyHeader sx={{ tableLayout: { xs: "fixed" } }}>
        <TableHead>
          <TableRow>
            <TableCell>Case Id</TableCell>
            <TableCell>Outcome</TableCell>
            <TableCell>Intake Id</TableCell>
            <TableCell>Pages</TableCell>
            <TableCell>Chat Id</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sampleEvents.map((sampleEvent, index) => (
            <TableRow hover key={index} selected={false}>
              <TableCell>
                <P>{sampleEvent.caseId}</P>
              </TableCell>
              <TableCell>{sampleEvent.outcome}</TableCell>
              <TableCell className="truncate">
                <Link
                  to={AppRoutes.caseDocumentsBuilder({
                    lensId,
                    caseId: sampleEvent.caseId,
                    documentId: sampleEvent.intakeId,
                    page: sampleEvent.intakePageNumbers[0],
                  })}>
                  <DocumentName name={sampleEvent.intakeName} />
                </Link>
              </TableCell>
              <TableCell>{sampleEvent.intakePageNumbers.join(", ")}</TableCell>
              <TableCell>
                {sampleEvent?.chatId && (
                  <Link to={AppRoutes.aiChatBuilder(lensId, sampleEvent.chatId)}>{sampleEvent.chatId}</Link>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SampleEventTable;
